<template>
  <div class="content content-full">
    <div class="page-inner">
      <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-2">
        <div>
          <h2 class="pb-0 fw-bold">{{ $t('sales_reports') }}</h2>
        </div>
      </div>
      <div class="mt-3">
        <div class="row">
          <div class="col-md-9">
            <div class="card p-3 mb-3">
              <div class="d-flex align-items-center">
                <span class="stamp stamp-md bg-info mr-3">
                  <i class="fa fa-info"></i>
                </span>
                <div>
                  <h2 class="mb-1 lead">
                    {{ $t('report_schedule') }}
                  </h2>
                </div>
              </div>
              <div class="mt-3">
                {{ $t('report_schedule_info') }}
              </div>
            </div>
            <div class="alert alert-warning" v-if="!user.subscription">
              {{ $t('unlock_to_reduce_cashout_and_more') }}<br/> <router-link :to="`/upgrade?from=statements&next=/statements`" class="btn btn-primary btn-sm mt-2">{{ $t('upgrade_now') }}</router-link>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-stats card-round mb-2" :class="{ 'card-success': balance >= minBalance, 'card-default': balance < minBalance }">
              <div class="card-body ">
                <div class="row">
                  <div class="col-3">
                    <div class="icon-big text-center">
                      <i class="flaticon-coins text-success"></i>
                    </div>
                  </div>
                  <div class="col-9 col-stats">
                    <div class="numbers">
                      <p class="card-category">{{ $t('revenue') }}</p>
                      <h4 class="card-title">${{ balance.toFixed(2) }} USD</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary btn-lg btn-block" :disabled="!balance || requested || requesting" @click="requestPayment()">
              {{ $t('request_payment') }}
            </button>
          </div>
        </div>

        <div class="mb-2 mt-4">
          <select class="form-control" v-model="currentStatementArtist" style="height: 38px !important;" @change="getRoyalties()">
            <option :value="artist" v-for="(artist, index) in statementArtists" v-bind:key="`artists_select_${index}`">
              {{ artist.name }}
            </option>
          </select>
        </div>

        <p v-if="currentArtist && !loading && !statements.length" class="text-muted p-2">
          {{ $t('no_royalties_yet') }}
        </p>

        <div class="card mt-3" v-if="currentArtist || currentStatementArtist">
          <div class="card-body p-0">
            <!-- <h3>{{ artist.name }}</h3> -->
            <p v-if="loading" class="p-5 text-center">
              <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
            </p>
            <div class="row" v-if="!loading">
              <div class="col-md-12 mb-3">
                <div class="table-responsive">
                  <table class="table table-striped table-head-bg-info mb-0">
                    <thead>
                      <tr>
                        <th>{{ $t('report') }}</th>
                        <th>{{ $t('royalties') }}</th>
                        <th width="10%"></th>
                      </tr>
                    </thead>
                    <tbody v-if="!statements.length">
                      <tr>
                        <td colspan="3">
                          {{ $t('no_royalties_yet') }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="3">
                          <div class="mt-3 mb-3">
                            <i class="fa fa-info-circle text-info mr-1"></i> <span v-html="$t('get_more_streams')"></span>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                    <tbody v-if="statements.length">
                      <tr class="pointer" v-for="(statement, index) in statementPeriods" v-bind:key="`statements_${index}`" @click="showReportDetails(statement)">
                        <td>
                          {{ moment(statement.reportingPeriod).format('MMMM, YYYY') }}
                        </td>
                        <td>
                          ${{ statement.amount.toFixed(2) }} USD
                        </td>
                        <td class="text-right">
                          <div v-if="!statement.dsp">
                            <a :href="`/v1/api/user/download-statement?id=${statement.balanceItemId.replace('-', '')}&artist_id=${currentStatementArtist._id || ''}`" target="_blank" class="btn btn-default btn-sm">
                              <i class="fa fa-download"></i>
                            </a>
                          </div>
                          <div v-if="statement.dsp">
                            {{ statement.dsp }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3 card" v-if="payouts.length">
          <div class="card-body p-0">
            <table class="table mb-0 table-head-bg-success">
              <thead>
                <tr>
                  <th>{{ $t('payment_request') }}</th>
                  <th>{{ $t('amount') }}</th>
                  <th>{{ $t('paid') }} </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in payouts" v-bind:key="`request_${index}`">
                  <td>{{ moment.utc(request.createdAt).format('LL') }}</td>
                  <td>
                    ${{ request.amount.toFixed(2) }} USD
                  </td>
                  <td>
                    <i class="fa fa-check text-success" v-if="request.paid"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
// import Vue from 'vue'
import User from '../services/user'
import Artist from '../services/artists'
import moment from 'moment'

export default {
  name: 'Account',
  data () {
    return {
      requested: false,
      requesting: false,
      user: {},
      balance: 0,
      minBalance: 100,
      moment: moment,
      currentArtist: null,
      currentStatementArtist: null,
      artists: [],
      statementArtists: [],
      payouts: [],
      currentReport: {},
      loadingSongs: false,
      paid: 0,
      statements: []
    }
  },
  computed: {
    statementPeriods: function () {
      return _.filter(this.statements, item => item.balanceTypeName !== 'Payment')
    }
  },
  methods: {
    pendingPayment: function () {
      let pending = false

      _.each(this.payouts, item => {
        if (!item.paid) {
          pending = true
        }
      })

      return pending
    },
    requestPayment () {
      if (this.requesting) return

      if (this.user.possibly_fake) {
        return this.$notify({ message: this.$t('suspicious_activity_contact') }, 'warning', 'fa-exclamation')
      }

      if (!this.user.paypal_account) {
        return this.$notify({ message: this.$t('paypal_account_needed') }, 'warning', 'fa-exclamation')
      }

      if (this.balance >= this.minBalance) {
        if (this.pendingPayment()) {
          return this.$notify({ message: this.$t('already_sent_payment_request') }, 'warning', 'fa-exclamation')
        }

        this.requesting = true

        if (!this.currentArtist && this.artists && this.artists[0]) {
          this.currentArtist = this.artists[0]._id
        }

        User.requestPayment(this.currentArtist).then(response => {
          this.requesting = false
          this.requested = true
          this.$notify({ message: this.$t('payment_request_sent') }, 'success', 'fa-check')
        }).catch((response) => {
          this.requesting = false
          this.requested = false
          console.error('Error when requesting payment', response)
        })
      } else {
        this.$notify({ message: this.$t('minimum_payment_is') }, 'warning', 'fa-exclamation')
      }
    },
    showReportDetails: function (report) {
      this.details = []
      this.currentReport = report
      this.loadingSongs = true

      User.getMonthDetails(this.currentArtist, report.report_year, report.report_month).then(response => {
        this.details = response.data
        this.loadingSongs = false
        this.$forceUpdate()
      })
    },
    getPayouts: function () {
      User.getPayouts(this.currentStatementArtist._id).then(response => {
        this.payouts = response.data
      })
    },
    getRoyalties: function () {
      this.balance = 0
      this.loading = true
      this.statements = []

      User.getInsights(this.currentStatementArtist._id, this.currentStatementArtist.r_id, 'store').then(response => {
        console.log('Insights', response.data)
      })

      User.getBalance(this.currentStatementArtist._id).then(response => {
        this.loading = false
        this.statements = response.data

        if (response.data[0]) {
          this.balance = response.data[0].balance
        }

        this.$forceUpdate()
      })
    }
  },
  created: function () {
    this.user = this.$user

    if (this.user.subscription) {
      this.minBalance = 50
    } else if (this.user.min_balance) {
      this.minBalance = this.user.min_balance
    }

    Artist.getAll().then(response => {
      this.statementArtists = _.filter(response.data, artist => artist.r_id)
      this.currentStatementArtist = this.statementArtists[0]

      this.getRoyalties()
    })
  }
}
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;

  &:hover td {
    background-color: #d9efff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatementsNew.vue